import React, { Component } from 'react';

class SearchEmployeeModal extends Component {

    render() {
        const { employees, SearchOneEmployee, CloseSearchEmployeeModal } = this.props;
        
        return (
            <div className="modal fade bd-example-modal-lg modal-open scroll" id="searchEmployeeModal" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="searchEmployeeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">Lista de empleados</h4>
                            &nbsp;
                            <button type="button" className="close" onClick={CloseSearchEmployeeModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" style={{ marginBottom: 0, minheight: 400, maxHeight: 500 }}>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                <tr>
                                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Nombre del empleado</td>
                                                    <td className="sticky-header table-header-yellow" style={{ textAlign: "center" }}>Correo</td>
                                                    <td className="sticky-header table-header-yellow"
                                                        style={{ width: 50, textAlign: "center" }}> 
                                                    </td>
                                                </tr>
                                                {!!employees && employees.map((employee, index) => {                                                    
                                                    return(
                                                        <tr key={index}>                                                            
                                                            <td>{employee.firstName + ' ' + employee.lastName}</td>
                                                            <td>{employee.email}</td>
                                                            
                                                            <td className="sticky-column">
                                                                <button type="button" className="btn botonCorrect"
                                                                    onClick={() => SearchOneEmployee(employee.empID)}>
                                                                        Seleccionar
                                                                </button>
                                                            </td>
                                                        </tr>                                  
                                                    )
                                                })}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white"
                                onClick={CloseSearchEmployeeModal}>
                                    Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchEmployeeModal;